import type { FaireProductEntity } from "../../entity_types/product";

export const p_q7n6gmzsmq: FaireProductEntity = {
  token: "p_q7n6gmzsmq",
  type: "product",
  name: "Dreamy Drop Squishy Viral Sensory Toy - Purple Haze",
  brandToken: "b_3jrwkg3xqx",
  brandName: "The Classy Cloth WS",
  imageUrl:
    "https://cdn.faire.com/fastly/35750732ddfc3a74977a283aa59daec66ac9b947371676220454226998b0ca3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f206006ea632ff35cb66cf121381f2433c4b20fdf686cca7b808ea723c0f376.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Tap into the viral squishy trend with these Dreamy Drop Squishies—an ultra-satisfying sensory toy customers can’t stop squeezing. Featuring a glossy, jelly-like texture with floating glitter details, each drop delivers a calming, addictive fidget experience perfect for all ages.\n\nDesigned to drive impulse purchases, this under $10 item is a must-have for checkout displays, kids sections, and giftable add-ons. A proven margin builder, these sensory drops are ideal for back to school, Easter baskets, stocking stuffers, and everyday gifting.\n\nWhy shops love it:\n\n• High sell-through impulse item\n\n• Trend-driven sensory toy category\n\n• Appeals to kids, tweens, teens & adults\n\n• Perfect for checkout displays & add-ons\n\nDetails:\n\n• Soft, squishy sensory stress toy\n\n• Glitter-filled, vibrant colors\n\n• Includes display stand (as shown)\n\n• Compact, lightweight, and giftable\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:44.444Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
